import React, { useEffect,useContext   } from "react";
import helpers from '../_helpers/helpersFunction';
import Context from '../context/context';
import Lang from '../lang/translations';

var MatchItemProps = {
  profile: null,
  open: false,
  first: false,
  onToggle: function() {}
};

export const MatchItem = (props) => {

  const {collection_folder, default_folder} = helpers.getCDNfolder()
  const  context = useContext(Context)

  if (!props.profile) return null;


   

  return (
    <div className={`${props.first ? 'first-card ' : 'back-card'} transition duration-100 ease-out`}>
      <div
        className={`match-wrapper cardMatch rounded-2xl border border-gray-300 ${props.profile.first ? 'shadow-lg' : ''} ${
          props.open && props.first ? 'card-open bg-white ' : ''
        }`} style={context.flusso.messaggi_inviti ? ({height: "calc(92vh - 160px)"}):({height: "calc(92vh - 93px)"})}
      >
        {props.first && !props.open ? (
          <div className="d-block d-md-none absolute left-0 right-0 top-0  h-12 rounded-t-2xl bg-black/30 pl-6 pt-1 text-white transition duration-200">
            <h1 className="text-xl font-bold">{props.profile.screenName}</h1>
            <h3 className="leading-3"> {props.profile.age} <Lang w={"anni"} page={"match"}></Lang></h3>
          </div>
        ) : null}

        <div
          className={`d-block d-md-none absolute right-6 top-2  ${
            props.open ? 'rounded-full bg-black/60 text-white' : 'text-white'
          }`}
          onClick={() => props.onToggle()}
          onTouchStart={() => props.onToggle()}
          onKeyDown={() => undefined}
          role="button"
          tabIndex={0}
        >
          <svg className="h-8 w-8" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
        </div>
        <img
          src={process.env.REACT_APP_CDN+'/'+default_folder+'/' + props.profile.id + '.jpg'}
          alt={props.profile.screenName}
          className={`${
            props.open && props.first ? 'h-80' : 'h-full'
          } w-full rounded-2xl bg-white object-cover transition-height duration-200 ease-in match-photo`}
        />

        <div className={`${props.open && props.first ? 'info-bottom-show px-4 py-2' : 'info-bottom-hide'}`}>
          <div className={`${props.open && props.first ? '' : 'opacity-0'} flex flex-col gap-1`}>
            <div className="text-2xl font-bold">{props.profile.screenName}</div>
            <div className="mb-2 flex gap-2">
              {props.profile.age} <Lang w={"anni"} page={"match"}/> <div className="profile-online"></div>{' '}
            </div>
            <div className="text-lg font-bold"><Lang w={"su_di_me"} page={"match"}></Lang></div>
            <div className='f-12'>{props.profile.description.length > 300 ? props.profile.description.substring(0, 300)+"..." : props.profile.description}</div>
          </div>
        </div>
      </div>
    </div>
  );
}